/* campaign-analytics.js — campaign semantic events → dataLayer/Klaviyo. */
(function(){
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__campaignAnalyticsBound) return;
  window.__campaignAnalyticsBound = true;

  // dataLayer event names stay campaign_* (internal); GTM maps ALL FOUR to the STANDARD
  // GA4 names (view_item_list/view_item/select_item/add_to_cart) on the tag's Event Name
  // so "Send Ecommerce data" attaches items. The ATC output rename to standard add_to_cart
  // is P2 (2026-07-10; GA4-side effect lands with the GTM B1/B2 publish — the dataLayer
  // name below never changes): the old "let the native app own add_to_cart" premise was
  // DISPROVEN by measurement (the Google&YouTube app sends NO add_to_cart to this GA4
  // property), so we own it; campaign slicing rides on the promo_id param. item_id is
  // PRODUCT-level (variant on item_variant), matching the site_* dispatcher. Only
  // campaign:atc may carry value/currency — hard-gated in handle(); view/select payloads
  // stay price-free. Order-side attribution still lives on the cart line properties.
  var EVENT_MAP = {
    'campaign:view': 'campaign_view_item_list',
    'campaign:tabview': 'campaign_view_item',
    'campaign:learnmore': 'campaign_select_item',
    'campaign:atc': 'campaign_cart_add'
  };
  var KLAVIYO_MAP = {
    'campaign:tabview': 'Campaign Bundle Viewed',
    'campaign:atc': 'Campaign Added to Cart'
  };
  var seenViews = {};
  var cfgCache = null;

  function config(){
    if (cfgCache) return cfgCache;
    var cfg = {};
    try {
      var el = document.getElementById('campaign-fp-config');
      if (el && el.textContent) cfg = JSON.parse(el.textContent) || {};
    } catch(e){ cfg = {}; }
    cfgCache = cfg;
    return cfg;
  }

  function promoId(){
    var v = config().campaign;
    return v == null ? '' : String(v).trim();
  }

  function analyticsAllowed(){
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() !== false;
    } catch(e){}
    return true;
  }

  function asString(v){ return v == null ? '' : String(v); }

  function normalizeItems(items, itemListId){
    if (!items || !items.length) return [];
    var out = [];
    for (var i=0;i<items.length;i++){
      var it = items[i] || {};
      var item = {
        item_id: asString(it.item_id),
        item_name: asString(it.item_name),
        item_list_id: itemListId,
        quantity: Number(it.quantity || 1)
      };
      if (it.item_variant) item.item_variant = asString(it.item_variant);   // standard GA4 field; item_id is product-level since P2 2026-07-10
      if (it.bundle_key) item.bundle_key = asString(it.bundle_key);
      if (it.bundle_role) item.bundle_role = asString(it.bundle_role);
      // channel passthrough removed (2026-07-10, Bill ruling): the emitted value was the
      // row's UI slot key, not the camera channel count — wrong for the A119/Telephoto/
      // Waterproof rows. Sources no longer emit it.
      out.push(item);
    }
    return out;
  }

  function pushDataLayer(payload){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  }

  function pushKlaviyo(sourceType, payload){
    if (!config().kl || !KLAVIYO_MAP[sourceType]) return;
    var q = window.klaviyo || window._learnq;
    if (!q || typeof q.push !== 'function') return;
    try { q.push(['track', KLAVIYO_MAP[sourceType], payload]); } catch(e){}
  }

  function handle(ev){
    var eventName = EVENT_MAP[ev.type];
    if (!eventName) return;
    if (!analyticsAllowed()) return;

    var promo = promoId();
    if (!promo) return;
    var detail = ev.detail || {};
    var listKey = asString(detail.listKey || detail.anchorId || detail.rowId || detail.tabType || 'campaign');
    var itemListId = promo + ':' + listKey;

    if (ev.type === 'campaign:view'){
      var dedupeKey = promo + '|' + listKey;
      if (seenViews[dedupeKey]) return;
      seenViews[dedupeKey] = true;
    }

    var payload = {
      event: eventName,
      promo_id: promo,
      ecommerce: {
        item_list_id: itemListId,
        items: normalizeItems(detail.items, itemListId)
      }
    };
    // value/currency: HARD-GATED to the ATC event type (P2 2026-07-10) — view/tabview/
    // learnmore payloads must stay price-free even if a (buggy) producer attaches value
    // to their detail. Campaign ATC is the ONLY event allowed to carry money; the amount
    // comes from the real cart state of THIS add (see campaignAtcValue in campaign.js).
    if (ev.type === 'campaign:atc'){
      var val = detail.value, cur = detail.currency;
      if (typeof val === 'number' && isFinite(val) && val > 0 && typeof cur === 'string' && cur){
        payload.ecommerce.value = val;
        payload.ecommerce.currency = cur;
      }
    }
    pushDataLayer(payload);
    pushKlaviyo(ev.type, payload);
  }

  Object.keys(EVENT_MAP).forEach(function(type){
    document.addEventListener(type, handle);
  });
})();
